export const Invoice = (json: ITransactionInvoice): ITransactionInvoiceModel => {
	const fromJSON = (transactionInvoice: ITransactionInvoice) => {
		const { document_url, ...rest } = transactionInvoice
		return {
			documentURL: document_url,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const Receipt = (json: ITransactionReceipt): ITransactionReceiptModel => {
	const fromJSON = (transactionReceipt: ITransactionReceipt) => {
		const { cart_id, created_at, document_public_url, document_token, updated_at, ...rest } = transactionReceipt
		return {
			cartID: cart_id,
			createdAt: new Date(created_at),
			documentPublicURL: document_public_url,
			documentToken: document_token,
			updatedAt: new Date(updated_at),
			...rest,
		}
	}

	return { ...fromJSON(json) }
}
